import { reviews } from "../../../mocks/Cleario";
import WaveDivider from "./WaveDivider";

export default function ReviewsSection() {
  return (
    <div>
      <section className="py-20" style={{ background: "#edf2fc" }}>
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          {/* Header */}
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
            <div>
              <div className="inline-flex items-center gap-2 bg-white rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
                <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Real Customers</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">
                200+ happy clears<br />and counting.
              </h2>
            </div>

            {/* Trustpilot badge */}
            <div className="bg-white rounded-2xl px-6 py-5 cartoon-card flex items-center gap-5">
              <div>
                <div className="flex items-center gap-0.5 mb-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#00b67a] text-xl"></i>
                  ))}
                </div>
                <p className="text-cl-dark font-black text-xl leading-none">4.8 / 5</p>
                <p className="text-gray-500 text-xs mt-0.5 font-semibold">200+ verified reviews</p>
              </div>
              <div className="w-px h-14 bg-gray-200"></div>
              <div>
                <p className="text-cl-green font-black text-3xl leading-none">200+</p>
                <p className="text-gray-500 text-xs mt-0.5 font-semibold">Happy customers</p>
              </div>
            </div>
          </div>

          {/* Review cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-10">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="flex flex-col justify-between bg-white rounded-2xl p-6 cartoon-card"
              >
                <div>
                  <div className="flex items-center gap-0.5 mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-[#00b67a] text-sm"></i>
                    ))}
                  </div>
                  <p className="text-cl-dark text-sm leading-relaxed mb-5 font-semibold">&ldquo;{review.text}&rdquo;</p>
                </div>
                <div className="flex items-center gap-3 pt-4 border-t-2 border-transparent">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-cl-lime border-2 border-cl-dark text-cl-green font-black text-sm flex-shrink-0 cartoon-shadow-sm">
                    {review.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-cl-dark font-black text-sm leading-none">{review.name}</p>
                    <p className="text-gray-400 text-xs mt-0.5 font-semibold">{review.location} · {review.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="#"
              className="inline-flex items-center gap-2 bg-white text-cl-dark font-black text-sm px-7 py-3.5 rounded-2xl cartoon-btn cursor-pointer"
            >
              <i className="ri-external-link-line"></i>
              Read all 200+ reviews on Trustpilot
            </a>
          </div>
        </div>
      </section>

      {/* Wave into Blog */}
      <WaveDivider fromColor="#edf2fc" toColor="#ffffff" />
    </div>
  );
}
